export default function Container() {
    return {
        MuiContainer: {
            styleOverrides: {
                root: {},
            },
        },
    };
}
//# sourceMappingURL=Container.js.map